import React from "react";

function Content_post(props) {
  const { id, title, image, content } = props;
  return (
    <div className="content-post">
      <h2 className="post-title">{title}</h2>
      <div className="post-image">
        <img src={image} alt={title} title={title} className="img-fluid" />
      </div>
      <div className="post-text">{content}</div>
    </div>
  );
}

export default Content_post;
